import React from 'react'
import { List, Avatar, Typography } from 'antd'
import { TCallLog } from '../../../../context/types'
import { getLogCaptionByType } from '../../../../utils/call-logs'

interface TCallLogsModalProps {
	data: TCallLog[]
}

export default function CallLogsModal({ data }: TCallLogsModalProps) {
	if (!data.length) return null

	return (
		<div className="call-logs-modal">
			<Typography.Title level={3}>Call Logs</Typography.Title>

			<List
				itemLayout="horizontal"
				dataSource={data}
				renderItem={({ user, type, id, created_on }: TCallLog) => (
					<List.Item key={id}>
						<List.Item.Meta
							avatar={<Avatar src={user?.profile_pic_url} />}
							title={getLogCaptionByType(user.first_name, type)}
							description={new Date(created_on).toLocaleString()}
						/>
					</List.Item>
				)}
			/>
		</div>
	)
}
